import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import LoanAgreementLoanSpecificTermsPageUI from './LoanAgreementLoanSpecificTermsPageUI.js'

class LoanAgreementLoanSpecificTermsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      template: null
    }
  }

  render() {
    return (
      <LoanAgreementLoanSpecificTermsPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        template={this.state.template}
        loanSpecificTerm={this.state.loanSpecificTerm}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    // this.getTemplates(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    let loanSpecificTerm = (response.loan.loanSubType === 'standard' || response.loan.loanSubType === 'epc') ? 'po'
      : (response.loan.loanSubType === 'nbfc' || response.loan.loanSubType === 'nbfc_vehicle') ? 'nbfc'
        : response.loan.loanSubType === 'ppa' ? 'ppa'
          : response.loan.loanSubType === 'vehicle_loan' ? 'ev'
            : response.loan.loanSubType
    this.setState({ errorList: response.errorList, loan: response.loan, loanSpecificTerm: loanSpecificTerm })
    this.getTemplates(context, loanSpecificTerm)
  }

  getTemplates(context, loanSpecificTerm) {
    let templateCode = `loan_agreement_${loanSpecificTerm}`
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/templates/${templateCode}`,
      cacheKey: CacheKeys.Templates(this.props.match.params.loanId, templateCode),
      callback: this.getTemplatesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getTemplatesCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      template: response.template,
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    let templateCode = `loan_agreement_${this.state.loanSpecificTerm}`
    CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
    CacheManager.removeObject(CacheKeys.Templates(this.props.match.params.loanId, templateCode))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
    }
    else {
      this.setState({
        template: null,
        errorList: null,
      })
      this.getLoan(context)
      this.getTemplates(context, this.state.loanSpecificTerm)
    }
  }
}

export default withRouter(LoanAgreementLoanSpecificTermsPageSF)
